(() => {
  const accent = (title) => {
    if (title.querySelector('.zada-rose-keyword')) return;
    const phrase = 'income of your own';
    const text = title.textContent;
    const at = text.indexOf(phrase);
    if (at < 0) return;
    const span = document.createElement('span');
    span.className = 'zada-rose-keyword'; span.textContent = phrase;
    title.replaceChildren(document.createTextNode(text.slice(0, at)), span,
      document.createTextNode(text.slice(at + phrase.length)));
  };
  const init = () => document.querySelectorAll('.zada-copy-hero [data-story-title]').forEach(title => {
    if (title.dataset.roseReady) return;
    title.dataset.roseReady = 'true'; accent(title);
    new MutationObserver(() => accent(title)).observe(title, {childList:true});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
